// import { controllers } from "./Controllers";

import { controllers } from "./Controllers";

type screen = {
    w: number;
    h: number;
}

class MediaController {
    private _screen: screen
    private _sections: Array<{name: string; ref: any;}> = []
    constructor(){
        this._screen = {
            w: window.innerWidth,
            h: window.innerHeight
        }
        this.reinit = this.reinit.bind(this)
    }

    reinit(){
        this._screen = {
            w: window.innerWidth,
            h: window.innerHeight
        }
        this.reinitFunctions()
        // console.log('reinit', this._screen)
    }
    scroll = () => {
        if(this._screen.w > 800){
            return
        }
        const scrollPosition = window.scrollY;
        controllers().menu.setBlured(scrollPosition > 600)
    }

    reinitFunctions(){
        // controllers().page.home.homeSections.reinit()
        // controllers().page.lookup.heroLookup.resetRefPosition()
    }

    mainContentClicked(){
        // controllers().menu.userDrawer.hide()
    }

    get w(){
        return this._screen.w
    }

    get h(){
        return this._screen.h
    }

    get screen(){
        return this._screen
    }

    get isMobile(){
        return this._screen.w<600
    }

    setSectionRef = (name: string, ref: any) => {
        const find = this._sections.find(s=> s.name === name)
        if(find){
            find.ref = ref
        } else {
            this._sections.push({name, ref})
        }
    }

    scrollToSection = (name: string) => {
        const find = this._sections.find(s=>s.name === name && s.ref)
        if(find && find.ref?.offsetTop){
            window.scrollTo(0,find.ref.offsetTop-window.innerHeight*0.075)
        }
    }
}

export { MediaController}